import { render, staticRenderFns } from "./DatasourceDsTabGeneral.vue?vue&type=template&id=e54db15a&scoped=true&lang=pug"
import script from "./DatasourceDsTabGeneral.vue?vue&type=script&lang=js"
export * from "./DatasourceDsTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54db15a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e54db15a')) {
      api.createRecord('e54db15a', component.options)
    } else {
      api.reload('e54db15a', component.options)
    }
    module.hot.accept("./DatasourceDsTabGeneral.vue?vue&type=template&id=e54db15a&scoped=true&lang=pug", function () {
      api.rerender('e54db15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/DatasourceDsTabGeneral.vue"
export default component.exports